import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-redarrows",
  "use": "icon-redarrows-usage",
  "viewBox": "0 0 15 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 13\" id=\"icon-redarrows\">\r\n  <defs>\r\n    <style>\r\n      #icon-redarrows .cls-1 {\r\n        fill: #e33aa3;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-redarrows_红箭头\" class=\"cls-1\" d=\"M729.01,348.994l2.684-6.494-2.684-6.494,14.98,6.494Z\" transform=\"translate(-729 -336)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/redarrows.svg
// module id = dGjR
// module chunks = 127